var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6856 4.03563L17.6856 6.03563C18.0037 6.16287 18.1025 6.56512 17.8795 6.82526L15.0208 10.1604L15.4968 14.4446C15.5382 14.8172 15.1702 15.1011 14.8204 14.9665L11.9578 13.8655L9.45946 19.6968C9.36277 19.9224 9.11978 20.0404 8.88871 19.9874L8.80293 19.9594C8.57732 19.8627 8.45935 19.6198 8.51232 19.3887L8.54032 19.3029L11.0238 13.5065L8.3204 12.4665C7.96706 12.3306 7.88706 11.8666 8.17449 11.6202L11.5247 8.7486L12.0029 4.44465C12.0394 4.11624 12.3788 3.91291 12.6856 4.03563Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPin);
export default __webpack_public_path__ + "static/media/FilledPin.bef3abdd865fbd8624a54c9f6e907117.svg";
export { ForwardRef as ReactComponent };